import { FC, Fragment } from "react";
import React from "react";
import { makeStyles, createStyles, FormControl, Grid } from "@material-ui/core";
import { FormControlLabel } from "../core/FormControlLabel";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { Checkbox } from "../core/Checkbox";
import { Colors } from "../../styles";
import { useStyles } from "../../useStyles";
const useFormControlStyle = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        containerError: {
            backgroundColor: Colors.radiantRedFill,
            borderColor: Colors.radiantRed,
            borderStyle: "solid",
            borderWidth: "1px",
            borderRadius: 8,
        },
        formControlLabelStyle: {
            marginRight: 110,
        },
        checkboxStyle: {
            marginRight: 8,
        },
    }),
);

export const NewConnectionPersonalContributionCanDoBasePlateBushingForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } =
        useFormModel<ChangeNames.NEW_CONNECTION_PERSONAL_CONTRIBUTION_CAN_DO_BASE_PLATE_BUSHING>();
    const formControlClasses = useFormControlStyle();

    return (
        <Fragment>
            <FormControl
                component="fieldset"
                className={classes.container}
                style={{ display: "flex" }}
            >
                <Grid container spacing={7} className={formControlClasses.container}>
                    <Grid item>
                        <FormControlLabel
                            isCheckBox={true}
                            className={formControlClasses.formControlLabelStyle}
                            control={
                                <Checkbox
                                    className={formControlClasses.checkboxStyle}
                                    value="power"
                                    checked={
                                        values
                                            .newConnectionPersonalContributionCanDoBasePlateBushing
                                            .value.yes
                                    }
                                    onChange={(event, checked) =>
                                        setValues((values) => {
                                            values.newConnectionPersonalContributionCanDoBasePlateBushing.value.yes =
                                                checked;
                                            values.newConnectionPersonalContributionCanDoBasePlateBushing.value.no =
                                                !checked;
                                        })
                                    }
                                />
                            }
                            label="Bodenplattendurchdringung"
                            sublabel="Der Bodenplattendurchdringung <b>kann</b> in Eigenleistung ausgeführt werden."
                            text="Die Mindestanforderungen für die Erbringung von Eigenleistungen können Sie <a href='https://www.syna.de/content/dam/syna-de/dokumente/netzanschluss/weg-zum-netzanschluss/eigenleistungen-mindestanforderungen-syna-012015.pdf'>hier</a> als PDF Dokument herunterladen."
                            error={
                                values.newConnectionPersonalContributionCanDoBasePlateBushing
                                    .error !== null
                            }
                        />
                    </Grid>
                </Grid>
            </FormControl>
        </Fragment>
    );
};
